import React, { useEffect, useState } from 'react';
import { Flex } from '../../components/Flex';
import { Cover, FixedFlexBox } from '../../components/Cover';
import { Title, Paragraph } from '../../components/Text';
import img from '../../images/t4.png';
import { Circle } from '../../components/Circle';

const covers = [
    {
        key: 0,
        title: "About Service Platform",
        description: "The Service Platform is a web-based service that simplifies some routine operations, such as operating system and software updates, case logging, and system data analysis."
    },
    {
        key: 1,
        title: "T4 (Total Timeline Tracking Tool)",
        description: "T4 is a tool that systematically captures, consolidates, and creates a timeline view of important OpenVMS performance statistics. The T4 service provided by the portal allows you to visualise your system performance in a graph format and perform various analyses to identify performance issues or to help with capacity planning."
    },
    {
        key: 1,
        title: "SHC (System Health Check)",
        description: "SHC is a tool that assesses the health of your OpenVMS computing environment by identifying security, performance, and configuration problems based on a defined set of tests. SHC results can be uploaded to the Service Platform for display and analysis."
    }
];

const LoginCover = () => {
    const [ coverKey, setCoverKey ] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            let i = coverKey;
            if (i === covers.length - 1) i = -1;
            setCoverKey(++i);
        }, 5000);

        return(() => clearTimeout(timer));
    }, [coverKey])

    return(
        <>
            <Cover img={img} top={0} right={0} height="100%" />
            <FixedFlexBox left="488px" bottom="60px" width="640px" >
                <Title h1 color="#fff" margin={{ bottom: "9px" }}>{covers[coverKey].title}</Title>
                <Paragraph style={{ height: "88px", lineHeight: "24px" }} color="#fff" margin={{ bottom: "19px" }}>{covers[coverKey].description}</Paragraph>
                <Flex gap={{ right: 12 }}>
                    {covers.map((cover, idx) => (
                        <Circle key={`circle-${idx}`} filled={idx === coverKey} />
                    ))}
                </Flex>
            </FixedFlexBox>
        </>
    );
};

export { LoginCover };